/*
const components = {
  reset        : resolve => require(['../app/reset.vue'], resolve),
  login        : resolve => require(['../app/login.vue'], resolve),
  dashboard    : resolve => require(['../app/dashboard.vue'], resolve),
  doc          : require('../app/doc.vue'),
  cases        : require('../app/cases.vue'),
  // 这两个组件要提前加载，避免训练菜单显示不全和样式混乱
  evaluation   : require('../app/evaluation.vue'),
  train        : require('../app/train.vue'),
  activation   : resolve => require(['../app/activation.vue'], resolve),
  homepage     : resolve => require(['../components/service/dashboard/homepage.vue'], resolve),
  trainTime    : resolve => require(['../components/service/times/trainTime.vue'], resolve),
  userSet      : resolve => require(['../components/service/doc/userSet.vue'], resolve),
  timeList     : resolve => require(['../components/service/times/timeList.vue'], resolve),
  caselist     : resolve => require(['../components/service/doc/caselist.vue'], resolve),
  caseinfo     : resolve => require(['../components/service/case/baseInfo/caseinfo.vue'], resolve),
  // 需提前加载，否则导致诊断选择框消失
  caseDiag     : require('../components/service/case/caseDiag/caseDiag.vue'),
  // 该组件提前加载避免信息采集样式混乱
  evalRecord   : require('../components/service/evaluation/evalRecord.vue'),
  evalContent  : resolve => require(['../components/service/evaluation/evalContent.vue'], resolve),//wd
  recordDetail : resolve => require(['../components/service/evaluation/recordDetail.vue'], resolve),//wd
  startEval    : resolve => require(['../components/service/evaluation/startEval.vue'], resolve),//wd
  printWab     : resolve => require(['../components/service/evaluation/printWab.vue'], resolve),//wd
  print10      : resolve => require(['../components/service/evaluation/print10.vue'], resolve),//wd
  // 这两个组件要提前加载，避免训练时无黑色背景
  trainPlan    : require('../components/service/case/trainPlan/trainPlan.vue'),
  trainRecord  : require('../components/service/case/trainRecord/trainRecord.vue'),
  collectInfo  : resolve => require(['../components/service/case/collectInfo/collectInfo.vue'], resolve),
  caseOrder    : resolve => require(['../components/service/case/caseOrder/caseOrder.vue'], resolve),
  order        : resolve => require(['../app/order.vue'], resolve),
  orderList    : resolve => require(['../components/service/order/orderList.vue'], resolve),
  orderPay     : resolve => require(['../components/service/order/orderPay.vue'], resolve),
  orderInfo    : resolve => require(['../components/service/order/orderInfo.vue'], resolve),
  // 时间组件
  timeTicker   : resolve => require(['../components/common/timer/Ticker.vue'], resolve),
  trainTips    : resolve => require(['../components/common/timer/trainTips.vue'], resolve),
  //打印量表内图片
  printImg     : resolve => require(['../components/common/printImg.vue'], resolve),
}
 */
import reset        from '../app/reset.vue';
import login        from '../app/login.vue';
import dashboard    from '../app/dashboard.vue';
import doc          from '../app/doc.vue';
import cases        from '../app/cases.vue';
// 这两个组件要提前加载，避免训练菜单显示不全和样式混乱
import evaluation   from '../app/evaluation.vue';
import train        from '../app/train.vue';
import activation   from '../app/activation.vue';
import homepage     from '../components/service/dashboard/homepage.vue';
import trainTime    from '../components/service/times/trainTime.vue';
import userSet      from '../components/service/doc/userSet.vue';
import timeList     from '../components/service/times/timeList.vue';
import caselist     from '../components/service/doc/caselist.vue';
import caseinfo     from '../components/service/case/baseInfo/caseinfo.vue';
// 需提前加载，否则导致诊断选择框消失
import caseDiag     from '../components/service/case/caseDiag/caseDiag.vue';
// 该组件提前加载避免信息采集样式混乱
import evalRecord   from '../components/service/evaluation/evalRecord.vue';
import evalContent  from '../components/service/evaluation/evalContent.vue';
import recordDetail from '../components/service/evaluation/recordDetail.vue';
import startEval    from '../components/service/evaluation/startEval.vue';
import printWab     from '../components/service/evaluation/printWab.vue';
import print10      from '../components/service/evaluation/print10.vue';
// 这两个组件要提前加载，避免训练时无黑色背景
import trainPlan    from '../components/service/case/trainPlan/trainPlan.vue';
import trainRecord from '../components/service/case/trainRecord/trainRecord.vue';
import brainStatus from '../components/service/case/status/Status.vue';//status
import collectInfo  from '../components/service/case/collectInfo/collectInfo.vue';
import caseOrder    from '../components/service/case/caseOrder/caseOrder.vue';
import order        from '../app/order.vue';
import orderList    from '../components/service/order/orderList.vue';
import orderPay     from '../components/service/order/orderPay.vue';
import orderInfo    from '../components/service/order/orderInfo.vue';
// 时间组件
import timeTicker   from '../components/common/timer/Ticker.vue';
import trainTips    from '../components/common/timer/trainTips.vue';
//打印量表内图片
import printImg     from '../components/common/printImg.vue';
import seelog       from '../components/service/notice/seeLog.vue';
import AssessmentContainer  from '../components/bz/assess-container';

import noPage from '../components/common/404.vue';
import errorPage from  '../components/common/502.vue';
import timeoutPage from '../components/common/timeoutPage.vue';
const components = {
  reset        ,
  login        ,
  dashboard    ,
  doc          ,
  cases        ,
  // 这两个组件要提前加载，避免训练菜单显示不全和样式混乱
  evaluation   ,
  train        ,
  activation   ,
  homepage     ,
  trainTime    ,
  userSet      ,
  timeList     ,
  caselist     ,
  caseinfo     ,
  // 需提前加载，否则导致诊断选择框消失
  caseDiag     ,
  // 该组件提前加载避免信息采集样式混乱
  evalRecord   ,
  evalContent  ,
  recordDetail ,
  startEval    ,
  printWab     ,
  print10      ,
  // 这两个组件要提前加载，避免训练时无黑色背景
  trainPlan    ,
  trainRecord  ,
  brainStatus,//brainStatus
  collectInfo  ,
  caseOrder    ,
  order        ,
  orderList    ,
  orderPay     ,
  orderInfo    ,
  // 时间组件
  timeTicker   ,
  trainTips    ,
  //打印量表内图片
  printImg     ,
  seelog,
  //测评子系统的测评容器
  AssessmentContainer,
  //404页面
  noPage,
  //502页面
  errorPage,
  //登录超时页面
  timeoutPage,
}

let applyRouteTemplate = (template) =>
{
  for (var entry of template)
  {
    entry.component = components[entry.component];
    if (entry.children)
    {
      applyRouteTemplate(entry.children);
    }
  }
};

export {
  applyRouteTemplate,
}



// WEBPACK FOOTER //
// ./src/router/utils.js